import _ from 'lodash';
import $ from 'jquery';
import activateFocusTrap from '../utils/focusTrap';

const namespace = 'ar-modal';

var defaultConfig = {
  animationDuration: 150,
  parentElement: document.body,
  displayHeader: true,
  backdropClose: true,
  scrollLock: true,
  focusTrap: false,
  width: 500,
  ariaDescribedby: null,
  ariaLabelledby: null,
  previouslyActiveElement: null,
  frameStyle: null,
};

export class Modal {
  constructor(config) {
    this.config = _.defaults(config || {}, defaultConfig);
    this._modalRootEl = undefined;
    this._modalBackdropEl = undefined;
    this._modalFrameEl = undefined;
    this._modalContentWrapEl = undefined;
    this._modalCloseBtnEl = undefined;
    this._deactivateTrap = undefined;
    this.isAnimating = false;
    this.isNotTheOnlyModalInTheVillage = !!document.querySelector('.' + namespace);
    this._htmlEl = document.querySelector('html');
    this._eventListeners = [];
  }

  init() {
    this.initScaffold();
    this.initEventListeners();
    return this;
  }

  initScaffold() {
    this._modalRootEl = document.createElement('div');
    $(this._modalRootEl).addClass(namespace);
    this._modalRootEl.style.display = 'none';

    var header = `
            <div class="${namespace}-header">
                <img src="/Assets/built/img/artemis-logo.svg" alt="" class="${namespace}-logo">
                <button class="${namespace}-close-btn">
                    <span class="icon-cross"></span>
                </button>
            </div>
        `;

    header = this.config.displayHeader ? header : '';
    var ariaLabelledby = this.config.ariaLabelledby
      ? `aria-labelledby="${this.config.ariaLabelledby}"`
      : '';
    var ariaDescribedby = this.config.ariaDescribedby
      ? `aria-describedby="${this.config.ariaDescribedby}"`
      : '';
    var frameInlineCss = this.config.frameStyle ? `style='${this.config.frameStyle}'` : '';

    $(this._modalRootEl).html(`
            <div class="${namespace}-frame" role="dialog" tabindex="-1" ${ariaLabelledby} ${ariaDescribedby} ${frameInlineCss}">
                ${header}
                <div class="${namespace}-content-wrap"></div>
            </div>
            <div class="${namespace}-backdrop"></div>
        `);

    this._modalBackdropEl = this._modalRootEl.querySelector(`.${namespace}-backdrop`);

    this._modalFrameEl = this._modalRootEl.querySelector(`.${namespace}-frame`);
    this._setYPosition();

    this._modalContentWrapEl = this._modalRootEl.querySelector(`.${namespace}-content-wrap`);
    this._modalCloseBtnEl = this._modalRootEl.querySelector(`.${namespace}-close-btn`);

    this.config.parentElement.appendChild(this._modalRootEl);
  }

  _setYPosition() {
    const topPos = 30;
    const maxHeight = window.innerHeight - topPos - 30;

    this._modalFrameEl.style.maxWidth = this.config.width + 'px';
    this._modalFrameEl.style.top = topPos + 'px';
    this._modalFrameEl.style.maxHeight = maxHeight + 'px';
  }

  initEventListeners() {
    this.initCloseEventListeners();
    $(window).on('resize', _.throttle(this._setYPosition.bind(this), 250));
  }

  /** @protected Inits events controlling closing the modal. Override for custom behavior */
  initCloseEventListeners() {
    if (this._modalCloseBtnEl) {
      const callback = this._onCloseBtnClick.bind(this);
      this._eventListeners.push({
        element: this._modalCloseBtnEl,
        callback: callback,
        events: 'click keypress',
      });
      $(this._modalCloseBtnEl).on('click keypress', callback);
    }

    const onBackdropCallback = this._onBackdropClick.bind(this);
    if (this.config.backdropClose) {
      this._eventListeners.push({
        element: this._modalBackdropEl,
        callback: onBackdropCallback,
        events: 'click ',
      });
      $(this._modalBackdropEl).on('click', onBackdropCallback);
    }

    this._eventListeners.push({ element: document, callback: onBackdropCallback, events: 'keyup' });
    $(document).on('keyup', onBackdropCallback);
  }

  initCloseButton(selector) {
    this._modalCloseBtnEl = this._modalRootEl.querySelector(selector);
    if (this._modalCloseBtnEl) {
      let callback = this._onCloseBtnClick.bind(this);
      this._eventListeners.push({
        element: this._modalCloseBtnEl,
        callback: callback,
        events: 'click keypress',
      });
      $(this._modalCloseBtnEl).on('click keypress', callback);
    }
  }

  initButtonWithCallback(selector, callback) {
    let callbackBtnEl = this._modalRootEl.querySelector(selector);
    if (callbackBtnEl && typeof callback === 'function') {
      const onClick = function (e) {
        if (e.type === 'click' || e.which == 13) {
          callback();
        }
      };
      this._eventListeners.push({
        element: callbackBtnEl,
        callback: onClick,
        events: 'click keypress',
      });
      $(callbackBtnEl).on('click keypress', onClick);
    }
  }

  _disableScroll() {
    $('body').css('overflow', 'hidden');
  }

  _enableScroll() {
    $('body').css('overflow', 'auto');
  }

  _onCloseBtnClick(e) {
    if (e.type === 'click' || e.which == 13) {
      this.hide();
    }
  }

  _onBackdropClick(e) {
    if (e.type === 'click' || e.which == 27) {
      this.hide();
    }
  }

  show() {
    if (this.isAnimating) {
      return;
    }

    this.isAnimating = true;

    this._modalRootEl.style.display = 'block';

    return new Promise((resolve, reject) => {
      requestAnimationFrame(() => {
        this._modalRootEl.classList.add('show');

        if (this.config.scrollLock) {
          this._disableScroll();
        }

        if (this.config.focusTrap) {
          this._deactivateTrap = activateFocusTrap(this._modalFrameEl, {
            previouslyActiveElement: this.config.previouslyActiveElement,
          });
        }

        setTimeout(() => {
          this.isAnimating = false;

          resolve();
        }, this.config.animationDuration);
      });
    });
  }

  hide() {
    if (this.isAnimating) return;

    this.isAnimating = true;

    this._modalRootEl.classList.remove('show');
    return new Promise((resolve, reject) => setTimeout(resolve, this.config.animationDuration))
      .then(() => {
        this._modalRootEl.style.display = 'none';

        if (this.config.scrollLock) {
          this._enableScroll();
        }

        if (this.config.focusTrap && typeof this._deactivateTrap === 'function') {
          this._deactivateTrap();
        }

        this._eventListeners.forEach(({ element, events, callback }) => {
          $(element).off(events, callback);
        });

        this.isAnimating = false;

        return Promise.resolve();
      })
      .then(() => {
        this._modalRootEl.parentNode && this._modalRootEl.parentNode.removeChild(this._modalRootEl);
      });
  }

  setContent(element) {
    while (this._modalContentWrapEl.firstChild) {
      this._modalContentWrapEl.removeChild(this._modalContentWrapEl.firstChild);
    }

    if (typeof element === 'string') {
      $(this._modalContentWrapEl).html(element);
    }
    if (typeof element === 'object') {
      this._modalContentWrapEl.appendChild(element);
    }
  }
}
